export default __webpack_public_path__ + "static/media/best-offer.18fda3fd.png";